export const defaultChartData = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      label: '# of Votes',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

export const defaultOptions = {
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        gridLines: {
          color: 'rgba(0, 0, 0, .04)',
        },
        ticks: {
          display: false,
          beginAtZero: true,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          color: 'rgba(0, 0, 0, .04)',
        },
        ticks: {
          display: false,
          beginAtZero: true,
        },
      },
    ],
  },
};
